module.exports = __webpack_public_path__ + "media/images/mobile/dummy01-777eca051e49b5d23e452342f91a2ca3.jpg";